<template>
  <div v-if="org && curation">
    <BaseSectionContainer
      v-if="curation.edit"
      tag="section"
      size="middle"
      class="jps-curation-footer"
    >
      <h2 class="jps-section-heading heading-page-metadata heading-page-last-updated">
        {{ ls(dapLangGlobal.lastUpdated) }}
      </h2>
      <p class="is-size-7 text-center">{{ ldate(curation.edit.date) }}</p>
    </BaseSectionContainer>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

const { ls, ldate } = useI18n()

interface Props {
  curation: Curation
  org: Organization
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-footer {
  margin: 6rem auto 3rem;
  // max-width: lcuration-content-width;
  @include is-mobile {
    width: 100%;
    padding: 1rem;
    margin: 0;
  }
}
</style>
